import { fetchEndpoint } from "../network";

/**
 * 首页推荐 - 轮播图
 */

export default {
  // 列表
  list(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/list",
      "GET",
      params
    );
  },
  //锁定
  lock(params) {
    return fetchEndpoint(
      "/create-platform/content/article/lock",
      "GET",
      params
    );
  },
  // 来源列表
  source(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/sourceList",
      "GET",
      params
    );
  },

  // 详情
  detail(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/detail",
      "GET",
      params
    );
  },

  // 添加
  create(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/add",
      "POST",
      params
    );
  },

  // 编辑
  modify(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/modify",
      "POST",
      params
    );
  },

  // 评论导入
  importExcel(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/importExcel",
      "POST",
      params
    );
  },

  // 删除
  remove(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/remove",
      "POST",
      params
    );
  },
};
